<template>
  <ConfirmationModal
    v-model="dialogState"
    :title="i18n.global.t('common.confirmationModal.title')"
    :note="i18n.global.t('common.confirmationModal.confirmDelete')"
    :confirmBtnName="i18n.global.t('common.deleteBtn')"
    confirmBtnClass="bg-danger text-white"
    :loading="loading"
    @confirm="handleDelete"
    @cancel="closeModal"
  />

  <template
    v-if="props.isDeleteAuthority"
  >
    <button
      @click="dialogState = true"
      class="material-symbols-outlined"
    >
      delete
    </button>
  </template>
  <template
    v-else
  >
    <v-tooltip
        :text="props.tooltipMessage"
      >
      <template v-slot:activator="{ props }">
        <button
          class="material-symbols-outlined"
          v-bind="props"
          :disabled="!props.isDeleteAuthority"
          :style="!props.isDeleteAuthority ? 'opacity: 0.5' : ''"
        >
          delete
        </button>
      </template>
    </v-tooltip>
  </template>
</template>

<script setup lang="ts">
import 'gitart-vue-dialog/dist/style.css'
import ConfirmationModal from '@/components/Common/ConfirmationModal.vue'
import { ref } from 'vue';
import i18n from '@/lang/i18n';

const props = defineProps<{
  showFlash?: () => void,
  deleteAction: () => void,
  isDeleteAuthority: boolean,
  tooltipMessage: string,
}>();

const dialogState = ref(false);
const loading = ref(false);

function closeModal() {
  dialogState.value = false
}

async function handleDelete() {
  loading.value = true
  await props.deleteAction()
  loading.value = false
  dialogState.value = false
}
</script>

<style>
.modal-header {
  font-weight: 600;
}
</style>
<style lang="scss">
</style>
